var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadicineOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 9,
    fill: "url(#paint0_linear_11449_46976)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 25C18.6667 22.0545 21.0545 19.6667 24 19.6667C24.9891 19.6667 25.9153 19.9359 26.7093 20.4051L19.4051 27.7093C18.9359 26.9153 18.6667 25.9891 18.6667 25ZM21.2907 29.5949C22.0847 30.0641 23.0109 30.3333 24 30.3333C26.9455 30.3333 29.3333 27.9455 29.3333 25C29.3333 24.0109 29.0641 23.0847 28.5949 22.2907L21.2907 29.5949ZM24 17C19.5817 17 16 20.5817 16 25C16 29.4183 19.5817 33 24 33C28.4183 33 32 29.4183 32 25C32 20.5817 28.4183 17 24 17Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11.6667C13.0545 11.6667 10.6667 14.0545 10.6667 17C10.6667 19.9455 13.0545 22.3333 16 22.3333C16.367 22.3333 16.7241 22.2965 17.0681 22.2266L17.5986 24.84C17.081 24.9451 16.5462 25 16 25C11.5817 25 8 21.4183 8 17C8 12.5817 11.5817 9 16 9C20.4183 9 24 12.5817 24 17C24 17.5462 23.9451 18.081 23.84 18.5986L21.2266 18.0681C21.2965 17.7241 21.3333 17.367 21.3333 17C21.3333 14.0545 18.9455 11.6667 16 11.6667Z",
    fill: "#ffbb00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46976",
    x1: 7,
    y1: 6.5,
    x2: 85.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadicineOrderIcon);
export default __webpack_public_path__ + "static/media/MadicineOrderIcon.8448570b07086128b61f6ca04f79471f.svg";
export { ForwardRef as ReactComponent };